import { useState, useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
export const useDisplayInteractiveEducation = (interactiveContentTrackingProps, videoId) => {
  const [displayInteractiveEducation, setDisplayInteractiveEducation] = useState();
  useEffect(() => {
    setDisplayInteractiveEducation(undefined);
  }, [videoId, interactiveContentTrackingProps.id]);
  const handleDisplayInteractiveEducation = flag => {
    const action = (() => {
      switch (flag) {
        case 'QUIZ_ME':
          return 'ai-quiz-me-button-clicked';
        case 'SUMMARIZATION':
          return 'ai-summarize-button-clicked';
        case 'ADAPT_TO_INDUSTRY':
          return 'ai-adapt-to-industry-button-clicked';
        default:
          return 'ai-summarize-button-clicked';
      }
    })();
    if (interactiveContentTrackingProps) {
      UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, interactiveContentTrackingProps, {
        action
      }));
    }
    setDisplayInteractiveEducation(prev => prev === flag ? undefined : flag);
  };
  return {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation
  };
};